import { render, staticRenderFns } from "./ZFM.vue?vue&type=template&id=5372af06&scoped=true&"
import script from "./ZFM.vue?vue&type=script&lang=js&"
export * from "./ZFM.vue?vue&type=script&lang=js&"
import style0 from "./ZFM.vue?vue&type=style&index=0&id=5372af06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5372af06",
  null
  
)

export default component.exports